// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceByContentSection_container__E5WWT","title":"PriceByContentSection_title__xakbj","list":"PriceByContentSection_list__f1Xbv"};